import * as React from "react";
const SvgSol = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 397.7 311.7" {...props}><linearGradient id="sol_svg__a" x1={360.879} x2={141.213} y1={351.455} y2={-69.294} gradientTransform="matrix(1 0 0 -1 0 314)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
      stopColor: "#00ffa3"
    }} /><stop offset={1} style={{
      stopColor: "#dc1fff"
    }} /></linearGradient><path d="M64.6 237.9c2.4-2.4 5.7-3.8 9.2-3.8h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1z" style={{
    fill: "url(#sol_svg__a)"
  }} /><linearGradient id="sol_svg__b" x1={264.829} x2={45.163} y1={401.601} y2={-19.148} gradientTransform="matrix(1 0 0 -1 0 314)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
      stopColor: "#00ffa3"
    }} /><stop offset={1} style={{
      stopColor: "#dc1fff"
    }} /></linearGradient><path d="M64.6 3.8C67.1 1.4 70.4 0 73.8 0h317.4c5.8 0 8.7 7 4.6 11.1l-62.7 62.7c-2.4 2.4-5.7 3.8-9.2 3.8H6.5c-5.8 0-8.7-7-4.6-11.1z" style={{
    fill: "url(#sol_svg__b)"
  }} /><linearGradient id="sol_svg__c" x1={312.548} x2={92.882} y1={376.688} y2={-44.061} gradientTransform="matrix(1 0 0 -1 0 314)" gradientUnits="userSpaceOnUse"><stop offset={0} style={{
      stopColor: "#00ffa3"
    }} /><stop offset={1} style={{
      stopColor: "#dc1fff"
    }} /></linearGradient><path d="M333.1 120.1c-2.4-2.4-5.7-3.8-9.2-3.8H6.5c-5.8 0-8.7 7-4.6 11.1l62.7 62.7c2.4 2.4 5.7 3.8 9.2 3.8h317.4c5.8 0 8.7-7 4.6-11.1z" style={{
    fill: "url(#sol_svg__c)"
  }} /></svg>;
export default SvgSol;